import React from 'react';
import { observer } from 'mobx-react';
import '../../../../css/_decisionOverlay.scss';
import { useTranslation, Trans } from 'react-i18next';
import { FlexDiv } from '../../../design-system/containers';
import { TextDefault } from '../../../design-system/texts';
import { ThemedButton } from '../../../themed/themed-button/ThemedButton';

export const DecisionFeedbackMobile = observer(
    ({ subject, showAnswerVideo, tryAgain }) => {
        const { numberOfPossibleDecisions = 1, numberOfRightAnswers } = subject;
        const userDidAnswerCorrectly =
            numberOfRightAnswers / numberOfPossibleDecisions === 1;
        const { t } = useTranslation();

        return (
            <FlexDiv fullWidth gap={16} padding={24} column mobileOnly>
                <Trans
                    components={{
                        p: <TextDefault />,
                        b: <TextDefault bold />,
                    }}
                >
                    {t('decisionSubjectFeedbackInfo', {
                        count: numberOfRightAnswers,
                        numberOfRightAnswers,
                        numberOfPossibleDecisions,
                    })}
                </Trans>
                <FlexDiv gap={16} column>
                    <ThemedButton
                        mode={!userDidAnswerCorrectly ? 'primary' : 'secondary'}
                        maxWidth
                        onClick={tryAgain}
                        text={t('tryAgain')}
                    >
                    </ThemedButton>
                    <ThemedButton 
                        mode="secondary" maxWidth onClick={showAnswerVideo}
                        text={t('previewVideo')}>
                    </ThemedButton>
                </FlexDiv>
            </FlexDiv>
        );
    }
);
